verifyDocumentType